import { msg } from 'gt-react';
import { MagnifyingGlassIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
} from '../../route';

const QueryBuilderPage = lazyRouteComponent(
  () => import('./QueryBuilderPage'),
  'QueryBuilderPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/procurement/query-builder',
  staticData: {
    app: {
      nav: {
        label: msg('Query Builder', {
          context: 'sidebar nav label, Procurement section',
        }),
        icon: <MagnifyingGlassIcon className="h-4 w-4" weight="fill" />,
        group: 'Procurement',
        order: 36,
        groupOrder: 30,
      },
      access: {
        modulesAnyOf: [ProductModule.PROCUREMENT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Inventory }],
      },
    },
  },
  component: QueryBuilderPage,
  loader: () => ({
    crumb: msg('Query Builder', { context: 'page breadcrumb' }),
  }),
  // `q` holds a URL-safe JSON string encoding { base, mode, ir } for the
  // committed query. Kept permissive here; the page parses/guards the payload.
  validateSearch: z.object({ q: z.string().optional() }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT],
    });
  },
});
